// API Configuration
const API_CONFIG = {
  baseURL: 'https://glcompradeouro.de/api',
  // baseURL: 'http://localhost/gl-api/api',
  apiKey: '9bU7aLpQFkhxYnrZz3pN',
  headers: {
    'Content-Type': 'application/json',
    'api': '9bU7aLpQFkhxYnrZz3pN'
  }
};

export default API_CONFIG;